/**
 * Product Card — Add to Cart
 * Majid Alyousef 2026
 * ================================
 * Handles .pcrd__add-cart buttons (data-variant-id attribute).
 * POSTs to Shopify /cart/add.js via fetch.
 * Shows brief success state; updates cart count bubble if present.
 */

(function () {

  // ── Bind buttons ──────────────────────────────────────────────

  function bindAddToCart() {
    document.querySelectorAll('.pcrd__add-cart:not([data-cart-bound])').forEach(function (btn) {
      btn.dataset.cartBound = '1';
      btn.addEventListener('click', handleAddToCart);
    });
  }

  // ── Click handler ─────────────────────────────────────────────

  function handleAddToCart(e) {
    e.preventDefault();
    e.stopPropagation();

    var btn = this;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.dataset.adding) return;

    btn.dataset.adding = '1';

    // ── Phase 1: tap bounce ──────────────────────────────────────
    // Immediate scale-up/snap-back — fires before the network request
    btn.classList.add('is-tapping');
    setTimeout(function () { btn.classList.remove('is-tapping'); }, 280);

    // ── Phase 2: loading pulse ───────────────────────────────────
    // After bounce settles, pulse to show the request is in flight
    setTimeout(function () { btn.classList.add('is-loading'); }, 120);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.classList.remove('is-loading');

      if (data.status) {
        // Shopify error (e.g. sold out mid-session) — reset quietly
        delete btn.dataset.adding;
        return;
      }

      // ── Phase 3: success flash ───────────────────────────────────
      // Warm-tone flash for ~900ms, then reset
      btn.classList.add('is-success');
      setTimeout(function () {
        btn.classList.remove('is-success');
        delete btn.dataset.adding;
      }, 900);

      // Refresh the cart bubble / drawer
      refreshCart();
    })
    .catch(function () {
      btn.classList.remove('is-loading');
      delete btn.dataset.adding;
    });
  }

  // ── Cart refresh ──────────────────────────────────────────────
  // Tries common Dawn / custom theme patterns for updating the cart count.

  function refreshCart() {
    // 1. Dawn cart-notification / cart-drawer custom element
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCartCount(cart.item_count); });
      return;
    }

    // 2. Generic: fetch /cart.js and update count badge
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); });
  }

  function updateCartCount(count) {
    var badge = document.querySelector('.ma-cart-count');

    if (count > 0) {
      if (badge) {
        // Already exists — just update the number
        badge.textContent = count;
      } else {
        // Cart was empty — create the badge and append to the cart icon link
        var cartLink = document.getElementById('cart-icon-bubble');
        if (cartLink) {
          badge = document.createElement('span');
          badge.className = 'ma-cart-count';
          badge.setAttribute('aria-hidden', 'true');
          badge.textContent = count;
          cartLink.appendChild(badge);
        }
      }
    } else if (badge) {
      // Cart is now empty — remove the badge
      badge.remove();
    }

    // Dispatch a generic event so other theme JS can respond
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count } }));
  }

  // ── Init ──────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', bindAddToCart);
  document.addEventListener('shopify:section:load', bindAddToCart);

})();
